<div class="signup-form container">
    <form (submit)="submitForm(signInForm)" #signInForm="ngForm">
        <h2>Please Sign In</h2>
        @if (showSessionExpiredMessage) {
            <div class="alert alert-info" role="alert">Your session expired. Please sign in.</div>
        }
        <div class="form-group">
            <input
                type="text"
                class="form-control"
                [(ngModel)]="user.username"
                name="username"
                placeholder="Employee or Lessor Number"
                required
            />
        </div>
        <div class="form-group">
            <input type="password" class="form-control" [(ngModel)]="user.password" name="password" placeholder="Password" required />
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-success" [disabled]="isSigningIn">
                @if (isSigningIn) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Signing In</span>
                } @else {
                    <span>Sign In</span>
                }
            </button>
        </div>
        @if (sqlUnavailable) {
            <span style="color: red">SQL Server is not responding, please reach out to Cyber Advisors.</span>
        }
        @if (lockedOut) {
            <span style="color: red">*This account is locked. Try again in 15 minutes or contact IT.</span>
        }
        @if (rateLimited) {
            <span style="color: red">*Too many attempts. Please wait and try again.</span>
        }
        @if (failedLogin) {
            <span style="color: red">*Incorrect Employee Number or Password</span>
        }
    </form>
    <div class="text-center">Don't have a password? <a style="cursor: pointer" (click)="signup()">Register</a></div>
</div>
